<template>
    <div class="ocr-upload">
        <el-upload
            ref="uploadRef"
            :class="{ 'ocr-upload-container': true, 'upload-disabled': disabled }"
            :disabled="disabled"
            :accept="accept"
            action="upload"
            :before-upload="handleValidate"
            :http-request="submitUpload"
            :show-file-list="false"
            :drag="drag"
        >
            <i :class="[icon, 'upload_icon']" v-if="uploadDisplayType === 'icon'"></i>
            <i :class="[icon]" v-if="uploadDisplayType === 'iconAndText'"></i>
            <el-button class="upload_button" :disabled="disabled" size="small" type="primary" v-if="uploadDisplayType === 'button'">{{
                text
            }}</el-button>
            <span :class="[disabled ? 'text-disabled' : '', 'upload_text']" v-if="uploadDisplayType === 'text'" v-html="text"></span>
            <span :class="[disabled ? 'text-disabled' : '', 'upload_text']" v-if="uploadDisplayType === 'iconAndText'" v-html="text"></span>
            <slot name="default" />
        </el-upload>
        <div class="paste-box">
            <el-input :disabled="disabled" placeholder="截图后，在此处粘贴（Ctrl+V）上传图片" @paste.native="handlePaste" />
        </div>
    </div>
</template>
<script>
import { ossUpload, ocrUpload, supplierUploadFileWithAiOcr, supplierUploadFileUrlWithAiClassification } from '../../api/uploadAndDownload.js';
import { OSS_FILE_MAX_SIZE, SRM_FILE_MAX_SIZE } from '../../constant/constant.js';
import {checkSwitchAndCompress} from '../../utils/fileCompress.js'
import { mapGetters } from 'vuex'

const THOUSAND_TWENTY_FOUR = 1024;
export default {
    name: 'ocrUpload',
    props: {
        bucket: {
            type: String,
            default() {
                return 'srm';
            }
        },
        businessKey: { // 业务分组
            type: String,
            default: ''
        },
        publicRead: { // 公有读标识 0私有，1公有
            type: [Number, String],
            default: 1
        },
        disabled: {
            type: Boolean,
            default() {
                return false;
            }
        },
        accept: {
            type: String,
            default() {
                return '.jpg,.jpeg,.png';
            }
        },
        isBringOut: {
            type: Boolean,
            default() {
                return false;
            }
        },
        ocr: {
            type: String,
            default() {
                return '';
            }
        },
        flag: {
            type: [String, Number, Boolean, Object, Array]
        },
        icon: {
            type: String,
            default() {
                return 'icon iconfont icon-upload';
            }
        },
        uploadDisplayType: {
            type: String,
            default() {
                return '';
            }
        },
        supplierCode: {
            type: String,
            default() {
                return '';
            }
        },
        text: {
            type: String,
            default() {
                return '';
            }
        },
        drag: {
            type: Boolean,
            default() {
                return false;
            }
        },
        isNewOcrUpload: {
            type: Boolean,
            default() {
                return false;
            }
        },
        // size: {
        //     type: Number,
        //     default() {
        //         return 20;
        //     }
        // }
    },
    data() {
        return {
            uploadName: '',
            uploadLoading: false,
            valid: false, // 上传前校验是否通过
            ocrUploadResult: {}, //OCR结果备份
            AiOcrFetchFlag: false, //AI和OCR识别结果已获取标记
            aiType: [], //AI识别返回的类型
        };
    },
    computed: {
        ...mapGetters(['btnPermissions']),
    },
    methods: {
        getFileNameAndSize(file) {
            const index = file.name.lastIndexOf('.');
            const originName = file.name
                .substring(0, index)
                .replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/gi, '')
                .replace(/\s+/g, '');
            const originNameType = file.name.substring(index, file.length);
            this.uploadName = originName + '_' + new Date().getTime() + originNameType;
        },
        // 上传前校验格式、大小
        handleValidate(file) {
            this.getFileNameAndSize(file);
            if (this.ocr) {
                // 需要对接ocr的 只允许上传jpg/png/jepg
                const fileType = file.name.slice(file.name.lastIndexOf('.'));
                const uploadTypeReg = /\.(jpg|jpeg|png)$/;
                if (!uploadTypeReg.test(fileType.toLowerCase())) {
                    this.valid = false
                    return this.$message.warning('此处只支持jpg、jpeg、png格式文件');
                }
            }
            // 250410限制系统内部上传文件大小为15MB，限制OSS上传文件大小为30MB
            const maxSize = this.ocr ? SRM_FILE_MAX_SIZE : OSS_FILE_MAX_SIZE
            // 文件限制大小
            if (file.size > maxSize * THOUSAND_TWENTY_FOUR * THOUSAND_TWENTY_FOUR) {
                this.valid = false
                return this.$message.warning(`上传文件不能大于${maxSize}M`);
            }
            this.valid = true
        },
        // 上传
        async submitUpload(uploadData) {
            if (!this.valid) {
                return false
            }
            this.$emit('beforeUpload');
            const formData = new FormData();
            const file = new File([uploadData.file], this.uploadName, {
                type: uploadData.file.type
            });

            if(this.isNewOcrUpload){
                const newFile = await checkSwitchAndCompress(file)
                formData.append('file', newFile);
            }else{
                formData.append('file', file);
            }
            
            // 上传的可选参数 isBringOut
            if (this.isBringOut) {
                formData.append('isBringOut', this.isBringOut);
            }
            switch (this.ocr) {
            case 'idCardFont':
                formData.append('type', 'idcard');
                formData.append('side', 'front');
                break;
            case 'idCardBehind':
                formData.append('type', 'idcard');
                formData.append('side', 'back');
                break;
            case 'vehicle':
                formData.append('type', 'vehicle');
                break;
            case 'driving':
                formData.append('type', 'driving');
                break;
            case 'empCertificate':
                formData.append('type', 'empCertificate');
                break;
            case 'roadTransport':
                formData.append('type', 'roadTransport');
                break;
            case 'vehicleCheck':
                formData.append('type', 'vehicleCheck');
                break;
            case 'trailerVehicle':
                formData.append('type', 'trailerVehicle');
                break;
            case 'bankCard' :
                formData.append('type', 'bankCard');
                break;
            }
            // ocr上传
            if (this.ocr) {
                if(this.supplierCode){
                    //重置标识
                    this.AiOcrFetchFlag = false
                    this.ocrUploadResult = {}

                    //有传分公司编码才需要AI校验
                    //不管AI识别结果如何，都提前调用OCR上传
                    Promise.all([this.AiVailidate(this.ocr,formData, uploadData), this.handleParallelOcrUpload(formData)]).then(res => {
                    }).finally(() => {
                        this.uploadLoading = false;
                        this.$emit('uploadFinish');
                    })
                }else{
                    this.handleOcrUpload(formData);
                }
            } else {
                // oss上传
                this.handleOssUpload(uploadData);
            }
        },
        getCertificateName(type){
            let name = ''
            switch(type){
                case 'idCardFont':
                    name = '身份证人像面'
                    break;
                case 'idCardBehind':
                    name = '身份证国徽面'
                    break;
                case 'vehicle':
                    name = '行驶证'
                    break;
                case 'vehicleCheck':
                    name = '行驶证年审页'
                    break;
                case 'driving':
                    name = '驾驶证'
                    break;
                case 'empCertificate':
                    name = '从业资格证'
                    break;
                case 'roadTransport':
                    name = '道路运输证'
                    break;
            }
            return name
        },
        getPermission(type){
            let name = ''
            switch(type){
                case 'idCardFont':
                    name = '/keyData/detail-160'
                    break;
                case 'idCardBehind':
                    name = '/keyData/detail-170'
                    break;
                case 'vehicle':
                    name = '/keyData/detail-200'
                    break;
                case 'vehicleCheck':
                    name = '/keyData/detail-210'
                    break;
                case 'driving':
                    name = '/keyData/detail-180'
                    break;
                case 'empCertificate':
                    name = '/keyData/detail-190'
                    break;
                case 'roadTransport':
                    name = '/keyData/detail-220'
                    break;
            }
            return name
        },
        getAiType(type, res){
            let name = ''
            switch(type){
                case 'idCardFont':
                    name = ['身份证人像面', '身份证人像面和国徽页', '身份证人像面和身份证国徽页']
                    break;
                case 'idCardBehind':
                    name = ['身份证国徽面', '身份证人像面和国徽页', '身份证人像面和身份证国徽页']
                    break;
                case 'vehicle':
                    name = ['行驶证', '电子行驶证']
                    break;
                case 'vehicleCheck':
                    name = ['行驶证年审页', '空白年审页', '电子行驶证']
                    break;
                case 'driving':
                    name = ['驾驶证']
                    break;
                case 'empCertificate':
                    name = ['从业资格证']
                    break;
                case 'roadTransport':
                    name = ['道路运输证']
                    break;
            }
            return (res||[]).some(v => name.includes(v))
            // return res.includes(name)
        },
        AiVailidate(type,formData,uploadData){
            //需要统计调用AI识别次数
            this.$emit('aiCounter', this.flag, 'classificationNumber')

            const AIformData = new FormData();
            AIformData.append('file',formData.get('file'))
            AIformData.append('type',formData.get('type'))
            if(formData.get('side') === 'back'){
                AIformData.set('type', 'idCardBack')
            }else if (formData.get('side') === 'front'){
                AIformData.set('type', 'idCard')
            }
            formData.append('supplierCode', this.supplierCode)
            this.uploadLoading = true;
            return supplierUploadFileUrlWithAiClassification(AIformData).then(res => {
                if (res && +res.code === 0) {
                    this.aiType = res.data || []
                    if(!this.getAiType(type, res.data)){
                        //需要统计AI识别错误次数
                        this.$emit('aiCounter', this.flag, 'classificationErrorNumber')
                        //AI识别错误，可以提前把loading关掉
                        this.uploadLoading = false;
                        this.$emit('uploadFinish');
                        //AI证件提示错误 上传的证件不是身份证人像面，请按图片示例上传身份证人像面
                        this.$confirm(`上传的证件不是${this.getCertificateName(type)}${['vehicle', 'driving'].includes(type) ? '或正副页不齐全' : ''}，请按图片示例上传${['vehicle', 'driving'].includes(type) ? '完整的' : ''}${this.getCertificateName(type)}。`, '提示', {
                            confirmButtonText: '重新上传证件',
                            cancelButtonText: '继续使用该图片',
                            showCancelButton: this.btnPermissions.includes(this.getPermission(type)),
                            showConfirmButton: true,
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                            showClose:true,
                            distinguishCancelAndClose: true,
                            type: 'warning'
                        }).then(() => {
                            //重新上传
                            this.$refs['uploadRef'].$refs['upload-inner'].handleClick()
                        }).catch((action) => {
                            if(action === 'cancel'){
                                //需要统计继续使用次数
                                this.$emit('aiCounter', this.flag, 'continueUseNumber')
                                //继续使用： 普通上传，不走OCR   
                                if(this.ocrUploadResult.ossResult){
                                    //并行的OCR上传有结果就直接把Oss地址拿过来用
                                    this.$emit('uploadSuccess', { data: { ossResult: this.ocrUploadResult.ossResult }, flag: this.flag, aiFlag: true });
                                }else{
                                    //并行的OCR还没有上传结果，则调用普通OSS上传
                                    this.AiOcrFetchFlag = false //避免并行的ocr请求过慢，导致普通OSS执行完才返回ocr请求结果
                                    this.$emit('beforeUpload'); //重新触发Loading
                                    this.handleOssUpload(uploadData, true);
                                }
                            }
                        }); 
                    }else{
                        //AI识别正常
                        if(this.AiOcrFetchFlag){
                            //OCR已经拿到结果
                            if(this.ocrUploadResult.ossResult){
                                this.$emit('uploadSuccess', { data: this.ocrUploadResult, flag: this.flag, ocr: this.ocr, aiType: this.aiType });
                            }else{
                                this.$message.warning('证件OCR失败，请重新上传图片。')
                            }
                            this.AiOcrFetchFlag = false
                        }else{
                            //OCR还没拿到结果
                            this.AiOcrFetchFlag = true
                        }
                    }
                }else if(res && res.code === 'LSRM-AI002'){
                    //AI识别错误，可以提前把loading关掉
                    this.uploadLoading = false;
                    this.$emit('uploadFinish');
                    this.$message.warning('证件智能校验失败，请重新上传图片。')
                }
            }).catch(() => {
                //AI识别错误，可以提前把loading关掉
                this.uploadLoading = false;
                this.$emit('uploadFinish');
            })

        },
        // 并行orc上传
        handleParallelOcrUpload(formData) {
            // if(['front', 'back'].includes(formData.get('side'))){
            //     formData.set('type', 'idcard')
            // }
            this.uploadLoading = true;
            let api = this.isNewOcrUpload ? supplierUploadFileWithAiOcr : ocrUpload
            return api(formData).then(res => {
                if (res && +res.code === 0) {
                    if(this.AiOcrFetchFlag){
                        //AI识别有结果
                        this.$emit('uploadSuccess', { data: res.data, flag: this.flag, ocr: this.ocr, aiType: this.aiType });
                        this.AiOcrFetchFlag = false
                    }else{
                        //AI识别还没结果
                        this.AiOcrFetchFlag = true
                        this.ocrUploadResult = res.data
                    }
                }else if(res && res.code === 'LSRM-AI001'){
                    if(this.AiOcrFetchFlag){
                        this.$message.warning('证件OCR失败，请重新上传图片。')
                    }else{
                        this.AiOcrFetchFlag = true
                    }
                }
            })
        },
        // orc上传
        handleOcrUpload(formData) {
            this.uploadLoading = true;
            let api = this.isNewOcrUpload ? supplierUploadFileWithAiOcr : ocrUpload
            api(formData).then(res => {
                if (res && +res.code === 0) {
                    this.$emit('uploadSuccess', { data: res.data, flag: this.flag, ocr: this.ocr });
                }else if(res && res.code === 'LSRM-AI001'){
                    this.$message.warning('证件OCR失败，请重新上传图片。')
                }
            }).finally(() => {
                this.uploadLoading = false;
                this.$emit('uploadFinish');
            });
        },
        // oss上传
        handleOssUpload(uploadData, aiFlag) {
            this.uploadLoading = true;
            const file = new File([uploadData.file], this.uploadName, {
                type: uploadData.file.type
            });
            ossUpload(file, {
                bucket: this.bucket,
                businessKey: this.businessKey,
                publicRead: this.publicRead,
                callback: null
            }).then(res => {
                if (res && +res.code === 0) {
                    res.data.downUrl = decodeURIComponent(res.data.downUrl);
                    const lastPoint = res.data.downUrl.lastIndexOf('.');
                    // const lastLine = res.data.downUrl.lastIndexOf('_');
                    // const lastslash = res.data.downUrl.lastIndexOf('/');
                    // res.data.id = res.data.downUrl.slice(lastLine + 1, lastPoint);
                    // 0627 OSS版本升级，使用当前时间戳作id
                    res.data.id = (new Date()).getTime();
                    // 241205 修改，将当前文件的名称作为localFileName
                    // res.data.localFileName = res.data.downUrl.slice(lastslash + 1, lastLine) + res.data.downUrl.slice(lastPoint);
                    res.data.localFileName = uploadData.file.name;
                    res.data.type = res.data.downUrl.slice(lastPoint + 1);
                    this.$emit('uploadSuccess', { data: { ossResult: res.data }, flag: this.flag, aiFlag });
                }
            }).finally(() => {
                this.uploadLoading = false;
                this.$emit('uploadFinish');
            });
        },
        // 粘贴图片上传
        handlePaste(event) {
            const items = (event.clipboardData || window.clipboardData).items;
            let file = null;
            if (!items || items.length === 0) {
                return this.$message.warning('当前浏览器不支持粘贴图片，请使用点击上传');
            }
            for (let i = 0; i < items.length; i++) {
                file = items[i].getAsFile();
                break;
            }
            if (!file) {
                return this.$message.warning('粘贴内容为非图片，请重新截图');
            }
            // 图片大小和格式校验
            this.handleValidate(file);
            // 上传
            this.submitUpload({ action: 'upload', file: file, withCredentials: false });
        }
    }
};
</script>
<style lang="less">
.ocr-upload {
    .icon-disabled,
    .text-disabled,
    .upload-disabled .el-upload {
        cursor: not-allowed;
    }

    .el-upload {
        width: 100%;
    }

    .ocr-upload-container {
        margin-bottom: 15px;
        height: 120px;
    }

    .paste-box {
        .el-input__inner {
            border-color: #66b1ff;
        }
    }
}
</style>